import { Component, OnInit, ViewChild } from '@angular/core';
import { TdDataTableService, TdDataTableSortingOrder, ITdDataTableSortChangeEvent, ITdDataTableColumn, TdDialogService, 
  TdLoadingService, TdSearchBoxComponent } from '@covalent/core';
import { IPageChangeEvent } from '@covalent/core';
import { ViewContainerRef, OnDestroy } from '@angular/core';
import { Catalog } from '../catalog';
import { CatalogService } from '../catalog.service';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { SettingsService } from '../../../../shared/services/settings.service';
import { ExportService } from '../../../../shared/services/export.service';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { Utils } from '../../../../shared/utils';


@Component({
  selector: 'app-catalog-list',
  templateUrl: './catalog-list.component.html',
  styleUrls: ['./catalog-list.component.scss']
})
export class CatalogListComponent implements OnInit, OnDestroy {
  @ViewChild('searchBox') _searchBox: TdSearchBoxComponent;

  catalogs: Catalog[];
  subscriptions: Subscription[] = [];

  columns: ITdDataTableColumn[] = [
    { name: 'name', label: 'Name', tooltip: '' },
    { name: 'description', label: 'Description' },
    { name: 'notes', label: 'Notes' },
    { name: 'quantity', label: 'Quantity' },
    { name: 'deleted', label: 'Deleted' }
  ];

  filteredData: any[];
  filteredTotal: number;
  fromRow: number = 1;
  currentPage: number = 1;
  sortBy: string = 'name';
  selectedRows: any[] = [];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Ascending;
  selectable: boolean = true;
  multipleSelect: boolean = true;


  constructor(private _dataTableService: TdDataTableService,
    private _dialogService: TdDialogService,
    private _catalogService: CatalogService,
    private _loadingService: TdLoadingService,
    private _settingsService: SettingsService,
    private _viewContainerRef: ViewContainerRef,
    public _exportService: ExportService,
    public _authService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this._loadingService.register('loading');

    this.presetSearchBox();

    this.subscriptions.push(this._catalogService
      .getCatalogs()
      .subscribe((catalogs: Catalog[]) => {

        if (Array.isArray(catalogs)) {
          this.catalogs = catalogs;
        } else {
          this.catalogs = [];
        }
        this.filteredData = this.catalogs;
        this.filteredTotal = this.catalogs.length;
        this.filter();

        this._loadingService.resolve('loading');

      }));
  }

  presetSearchBox(): void {
    if (this._settingsService.getSearchTerm('catalog')) {
      this._searchBox.value = this._settingsService.getSearchTerm('catalog');
      this._searchBox.searchClicked();
    }
  }

  deleteCatalogs(): void {
    let deleteCatalogsCalls = [];
    let selectedCatalogs = this.selectedRows;
    let catalogIds = [];


    selectedCatalogs.forEach(cat => {
      let catalogId = cat.id;

      catalogIds.push(catalogId);

      deleteCatalogsCalls.push(
        this._catalogService
          .deleteCatalog(catalogId)
          .map((res: Response) => res)
      );

    });
    this.processDeletes(deleteCatalogsCalls, catalogIds, selectedCatalogs)

  }

  processDeletes(deleteCatalogsCalls: any, catalogIds: any, selectedCatalogs: any): void {
    Observable.forkJoin(deleteCatalogsCalls).subscribe(data => {
      this._dialogService.openAlert({
        message: 'Successfully deleted ' + (selectedCatalogs.length > 1 ? 'multiple catalogs' : '') + ' catalog!',
        title: 'Success',
      });


      this.catalogs = this.catalogs.filter((catalog: Catalog) => {
        return !~catalogIds.indexOf(catalog.id);
      });

      this.selectedRows.splice(0, this.selectedRows.length);
      this.filter();
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter();
  }

  search(searchTerm: string): void {
    this._settingsService.setSearchTerm('catalog', searchTerm);
    this.filter();
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;
    this._settingsService.setPageSize(pagingEvent.pageSize);
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.catalogs;
    let excludedColumns: string[] = this.columns
      .filter((column: ITdDataTableColumn) => {
        return ((column.filter === undefined && column.hidden === true) ||
          (column.filter !== undefined && column.filter === false));
      }).map((column: ITdDataTableColumn) => {
        return column.name;
      });

    newData = this._dataTableService.filterData(newData, this._settingsService.getSearchTerm('catalog'), true, excludedColumns);
    this.filteredTotal = newData.length;
    newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    this.filteredData = newData;
  }

}




// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/purchasing/catalogs/catalog-list/catalog-list.component.ts